import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';

export default function LeadTraceMatrixSection({
  leadKeys = [],
  metrices = [],
  notNormalMetrices = [],
  initialValues = {},
  onChange = () => {},
}) {
  const [formData, setFormData] = useState(initialValues);

  // Initialize formData on first mount or when leadKeys change
  // useEffect(() => {
  //   let lead_trace_quality = {};
  //   if (initialValues?.lead_trace_quality) {
  //     lead_trace_quality = initialValues?.lead_trace_quality
  //   } else {
  //     leadKeys.forEach((lead) => {
  //       const leadKey = `${lead}`;
  //       lead_trace_quality[leadKey] = {
  //         ...metrices.reduce((acc, type, i) => {
  //           acc[type] = i === 0; // default: normal = true
  //           return acc;
  //         }, {}),
  //         ...(initialValues?.lead_trace_quality?.[leadKey] || {}),
  //       };
  //     });
  //   }

  //   const merged = {
  //     lead_trace_quality,
  //     lead_2_q_pathalogical_wave: initialValues?.lead_2_q_pathalogical_wave ?? false,
  //   };

  //   setFormData(merged);
  // }, []);

  const handleMatrixChange = (leadKey, type) => (e) => {
    const isNotNormal = notNormalMetrices?.includes(type)

    const updated = {
      ...formData,
      lead_trace_quality: {
        ...formData.lead_trace_quality,
        [leadKey]: {
          ...formData.lead_trace_quality[leadKey],
          [type]: e.target.checked,
          ...(isNotNormal ? { "normal": false } : {})
        },
      },
    };
    setFormData(updated);
    onChange(updated);
  };

  const handleGlobalChange = (field) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const updated = { ...formData, [field]: value };
    setFormData(updated);
    onChange(updated);
  };

  return (
    <Box p={2}>
      {/* Matrix */}
      <Typography variant="span" fontWeight="bold" gutterBottom>
        Lead Trace Quality:
      </Typography>
      {/* Global Flags */}
      <Box>
        <Box display="flex" flexDirection="column" gap={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!formData.lead_2_q_pathalogical_wave}
                onChange={handleGlobalChange('lead_2_q_pathalogical_wave')}
              />
            }
            label="Lead 2 Q-Pathological Wave"
          />
        </Box>
      </Box>
      { leadKeys?.length ? <Box mt={2} sx={{ maxWidth: '38vw', overflowX: 'auto' }}>
        <TableContainer component={Paper} sx={{ maxHeight: (leadKeys?.length === 1 ? 200 : 400), overflow: 'auto' }}>
            <Table stickyHeader size="small" aria-label="lead trace matrix">
              <TableHead>
                <TableRow>
                  <TableCell sx={{
                    position: 'sticky',
                    top: 0,
                    left: 0,
                    zIndex: 3,
                    background: 'var(--app-surface)',
                    fontWeight: 'bold',
                  }}><strong>#</strong></TableCell>
                  {metrices.map((type) => (
                    <TableCell key={type} align="center"
                    sx={{
                      position: 'sticky',
                      top: 0,
                      left: 0,
                      zIndex: 3,
                      background: 'var(--app-surface)',
                      fontWeight: 'bold',
                    }}>
                      <strong>{type.replace(/_/g, ' ')?.replace(/\b\w/g, char => char.toUpperCase())}</strong>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {leadKeys.map((lead) => {
                  const leadKey = `${lead}`;
                  const leadData = formData.lead_trace_quality?.[leadKey] || {};
                  return (
                    <TableRow key={lead}>
                      <TableCell
                        sx={{
                          width: '80px',
                          position: 'sticky',
                          left: 0,
                          background: 'var(--app-surface)', // or your theme background
                          zIndex: 1, // ensure it stays above other cells
                          borderRight: '1px solid var(--app-border)',
                        }}
                      >{lead}</TableCell>
                      {metrices.map((type) => (
                        <TableCell key={type} align="center">
                          <Checkbox
                            checked={!!leadData[type]}
                            onChange={handleMatrixChange(leadKey, type)}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
        </TableContainer>
      </Box>: null }
    </Box>
  );
}
